///
/// EarthBrowser
///
/// Migration: v25 -> v26
/// Adds "webcam" dataset type support in visibleDatasets
///
/// Created by Matt Giger on 9/4/2026
/// Copyright (c) 2026 Geodata Labs
///

interface StateV25 {
	earthbrowser?: {
		visibleDatasets?: string[]
	}
}

/**
 * Migration from version 25 to 26: Add webcam dataset support
 * - Validates visibleDatasets so "webcam" is accepted going forward
 * - Webcams default to hidden (opt-in via the settings toggle)
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV25toV26(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV25
	const oldEarthbrowser = s.earthbrowser || {}

	const visibleDatasets = Array.isArray(oldEarthbrowser.visibleDatasets)
		? [...oldEarthbrowser.visibleDatasets]
		: ["cloud", "earthquake", "satellite", "aurora", "volcano"]

	// Filter out any invalid dataset types that might have crept in
	// webcam is now valid
	const validDatasets = visibleDatasets.filter((d: string) =>
		["satellite", "airport", "buoy", "webcam", "city_weather", "earthquake", "volcano",
		 "location", "cloud", "stars", "aurora", "wildfire",
		 "weather", "package", "devtools", "nexrad", "synoptic", ""].includes(d)
	)

	const newEarthbrowser = {
		...oldEarthbrowser,
		visibleDatasets: validDatasets,
	}

	return {
		...s,
		earthbrowser: newEarthbrowser
	}
}
